import { C8AttributeId, C8Node, C8NodeType } from "csi/typings";

// SustainabilityProfileRevision
export const ATTR_PROPERTIES_CUSTOM_VIEW: C8AttributeId = "PropertiesCustomView";
export const TYPE_SUSTAINABILITY_PROFILE_REVISION: C8NodeType = "SustainabilityProfileRevision";

// SustainabilityProfileSubtypeSettings
export const ATTR_APPLICABLE_FOR_TYPE: C8AttributeId = "ApplicableForType";

const SUSTAINABILITY_PROFILE = "SustainabilityProfile";
const SUSTAINABILITY_PROFILE_READ_ONLY_ATTRS = [
	"Node Name",
	"SPTemplate",
];
const SUSTAINABILITY_PROFILE_REVISION = "SustainabilityProfileRevision";
const SUSTAINABILITY_PROFILE_REVISION_READ_ONLY_ATTRS = [
	"ApplicableForColors",
	"FromBOM",
	"FromCareAndComposition",
];

/**
 * Return true if node is any of the BuildInAttributes in
 * SUSTAINABILITY_PROFILE_READ_ONLY_ATTRS/SUSTAINABILITY_PROFILE_REVISION_READ_ONLY_ATTRS
 */
export function isSustainabilityProfileFormAttribute(node: C8Node): boolean {
	return (node.ReflectionAttributeOwner === SUSTAINABILITY_PROFILE &&
		SUSTAINABILITY_PROFILE_READ_ONLY_ATTRS.includes(node.ReflectionAttributeId)) ||
	(node.ReflectionAttributeOwner === SUSTAINABILITY_PROFILE_REVISION &&
		SUSTAINABILITY_PROFILE_REVISION_READ_ONLY_ATTRS.includes(node.ReflectionAttributeId));
};
